import React from "react";
import { Helmet } from "react-helmet";
import TimelineCrafted from "../components/TimelineCrafted";

/**
 * AboutNew - 3D timeline about page
 * Uses same layout pattern as About.js - normal document flow
 */
const AboutNew = () => {
  return (
    <>
      <Helmet>
        <title>About - limkc.com</title>
        <meta name="description" content="About me - timeline of my journey." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Center crosshair - visible when debug-enabled class is on body */}
      <div className="debug-center-cross" style={{
        display: 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 9999
      }}>
        {/* Vertical line */}
        <div style={{
          position: 'absolute',
          left: '50%',
          top: 0,
          bottom: 0,
          width: '1px',
          background: 'rgba(255, 0, 0, 0.5)'
        }} />
        {/* Horizontal line */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: 0,
          right: 0,
          height: '1px',
          background: 'rgba(255, 0, 0, 0.5)'
        }} />
      </div>

      <style>{`
        body.debug-enabled .debug-center-cross {
          display: block !important;
        }

        /* Tablet (iPad Mini 744px - 1024px) - default for Chrome/other browsers */
        @media (min-width: 700px) and (max-width: 1024px) {
          .aboutnew-container {
            height: 100vh !important;
          }
        }

        /* Mobile portrait - fill available flex space instead of fighting viewport calc */
        @media (max-width: 767px) and (orientation: portrait) {
          .aboutnew-container {
            height: 100% !important;
            min-height: 0 !important;
            flex: 1 0 0% !important;
          }
          /* Prevent overflow below footer — only active when About page is mounted */
          .chatty-debug-container {
            height: 100vh !important;
            min-height: 0 !important;
            overflow: hidden !important;
          }
          #primary-main-content {
            padding-bottom: 0 !important;
            min-height: 0 !important;
          }
        }

        /* Safari only - use fixed positioning for iOS viewport quirks */
        @supports (-webkit-touch-callout: none) {
          @media (min-width: 700px) and (max-width: 1024px) {
            .aboutnew-container {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              right: 0 !important;
              bottom: 0 !important;
              height: auto !important;
              width: 100% !important;
            }
          }
        }
      `}</style>

      <div
        className="aboutnew-container"
        style={{
          width: '100%',
          height: 'calc(100vh - var(--footer-height, 70px))',
          overflow: 'hidden'
        }}
      >
        <TimelineCrafted />
      </div>
    </>
  );
};

export default AboutNew;
